module.exports = __webpack_public_path__ + "img/5_34.b0c08848.png";